import { render } from "./IdcardUpload.vue?vue&type=template&id=267d8448&scoped=true&ts=true"
import script from "./IdcardUpload.vue?vue&type=script&lang=ts"
export * from "./IdcardUpload.vue?vue&type=script&lang=ts"

import "./IdcardUpload.vue?vue&type=style&index=0&id=267d8448&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d8448"]])

export default __exports__